import ProductState from "./product--state.js";
import VariantColors from "./product--variant-colors.js";
import VariantFabrics from "./product--variant-fabrics.js";
import VariantSizes from "./product--variant-sizes.js";
import VariantSlits from "./product--variant-slits.js";
import VariantEstimatedArrival from "./product--variant-estimated-arrival.js";
import ArrivalModal from "./product--estimated-arrival-modal.js";
import UtmSwatchCarousel from "./product--utm-swatch-carousel.js";

customElements.define("product-state", ProductState);
customElements.define("variant-colors", VariantColors);
customElements.define("variant-fabrics", VariantFabrics);
customElements.define("variant-sizes", VariantSizes);
customElements.define("variant-slits", VariantSlits);
customElements.define("variant-estimated-arrival", VariantEstimatedArrival);
customElements.define("arrival-modal", ArrivalModal);
customElements.define("utm-swatch-carousel", UtmSwatchCarousel);

export {
  ProductState,
  VariantColors,
  VariantFabrics,
  VariantSizes,
  VariantSlits,
  VariantEstimatedArrival,
  ArrivalModal,
  UtmSwatchCarousel,
};
